module.exports = __webpack_public_path__ + "img/3-gallery.86397983.png";